import React, { createContext, useContext, useRef, useMemo } from "react";
import { GAME_LAYOUT } from "../settings";

export const ReelRefsContext = createContext(null);

// Initialize HoldAndWin tension overlay refs structure using settings constants
const INITIAL_HOLD_AND_WIN_TENSION_OVERLAYS = Array(GAME_LAYOUT.REEL_COUNT)
  .fill(null)
  .map(() => Array(GAME_LAYOUT.SYMBOLS_VISIBLE).fill(null));

export const ReelRefsProvider = ({ children }) => {
  const reelRefs = useRef([]);
  const overlayReelRefs = useRef([]);
  const infoReelRefs = useRef([]);
  const tensionReelRefs = useRef([]);
  const winLinesContainerRef = useRef(null);
  const winBoxContainerRef = useRef(null);
  const dimReelSetRef = useRef(null);
  const globalLineWinTextRef = useRef(null);
  const lineWinTextRef = useRef(null);

  // Free Spin
  const freeSpinReelRefs = useRef([]);
  const freeSpinOverlayReelRefs = useRef([]);
  const maskReelRefs = useRef([]);
  const freeSpinWinLinesContainerRef = useRef(null);

  // HoldAndWin
  const holdAndWinReelRefs = useRef([]);
  const holdAndWinOverlayReelRefs = useRef([]);
  const holdAndWinTensionOverlayRefs = useRef(INITIAL_HOLD_AND_WIN_TENSION_OVERLAYS);
  const holdAndWinCollectorControllerRef = useRef(null);
  const holdAndWinCollectorDisplayRef = useRef(null);
  const holdAndWinCoinCollectRef = useRef(null);
  const holdAndWinCounterRef = useRef(null);
  const holdAndWinProgressBarRef = useRef(null);
  const reelFrameDecorationRef = useRef(null);

  // Button refs for animation triggers
  const playButtonRef = useRef(null);

  // Game container ref for tension shake animation
  const gameContainerRef = useRef(null);

  // Background animation controller ref for background spine animations
  const backgroundAnimationControllerRef = useRef(null);

  const refs = useMemo(
    () => ({
      reelRefs,
      overlayReelRefs,
      infoReelRefs,
      tensionReelRefs,
      winLinesContainerRef,
      winBoxContainerRef,
      dimReelSetRef,
      globalLineWinTextRef,
      lineWinTextRef,
      // Free Spin
      freeSpinReelRefs,
      freeSpinOverlayReelRefs,
      maskReelRefs,
      freeSpinWinLinesContainerRef,
      // HoldAndWin
      holdAndWinReelRefs,
      holdAndWinOverlayReelRefs,
      holdAndWinTensionOverlayRefs,
      holdAndWinCollectorControllerRef,
      holdAndWinCollectorDisplayRef,
      holdAndWinCoinCollectRef,
      holdAndWinCounterRef,
      holdAndWinProgressBarRef,
      reelFrameDecorationRef,
      // Button refs for animation triggers
      playButtonRef,
      // Game container ref for tension shake animation
      gameContainerRef,
      // Background animation controller ref
      backgroundAnimationControllerRef,
    }),
    []
  );

  return (
    <ReelRefsContext.Provider value={refs}>{children}</ReelRefsContext.Provider>
  );
};

export const useReelRefs = () => {
  const ctx = useContext(ReelRefsContext);
  if (!ctx) throw new Error("useReelRefs must be used within ReelRefsProvider");
  return ctx;
};
